"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddressRowValue = void 0;
const getAddressRowValue = (addressRowConfigItem, address) => {
  const propertyName = addressRowConfigItem.charAt(0).toLowerCase() + addressRowConfigItem.slice(1);
  return address[propertyName] ?? '';
};
exports.getAddressRowValue = getAddressRowValue;